export default __webpack_public_path__ + "static/media/bg-3.947f9b64.png";